var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowExpandGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.512 3.852L.812.892a.5.5 0 00-.812.39v5.92a.5.5 0 00.812.39l3.7-2.96a.5.5 0 000-.78z",
    fill: "#262A33",
    fillOpacity: 0.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC41MTE5NiAzLjg1MTc1TDAuODEyMzQ4IDAuODkyMDY1QzAuNDg0OTY2IDAuNjMwMTYgNC40OTY5ZS0wNyAwLjg2MzI0NyA0LjMxMzY0ZS0wNyAxLjI4MjVMMS43MjYyZS0wNyA3LjIwMTg3QzEuNTQyOTNlLTA3IDcuNjIxMTMgMC40ODQ5NjYgNy44NTQyMSAwLjgxMjM0OCA3LjU5MjMxTDQuNTExOTYgNC42MzI2MkM0Ljc2MjE2IDQuNDMyNDYgNC43NjIxNiA0LjA1MTkyIDQuNTExOTYgMy44NTE3NVoiIGZpbGw9IiMyNjJBMzMiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";
export { SvgArrowExpandGray as ReactComponent };